var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReelay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 23.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M11.773 5.863h7.876l.725.9-.725 3.116-1.278 1.005H10.6ZM5.594 0 0 23.453h7.6l1.588-6.7h5.076l3.246 6.7h7.183l.38-1.608-3.073-5.9 4.665-3.683 1.755-7.373L24.553 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "m32.384 0-5.591 23.453h22.439l1.45-6.031H35.84l.725-3.183h10.7l1.281-5.361H37.84l.692-2.85h14.5L54.488 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "m56.513 0-5.594 23.453h22.44l1.453-6.031H59.967l.725-3.183h10.705l1.278-5.361H61.967l.692-2.85h14.5L78.614 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "m80.77 0-5.595 23.453h20.029l1.519-6.366H84.292L88.37 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M114.737 6.366h.866l1.062 7.2h-6.5ZM111.252 0 96.783 21.443l-.486 2.01h7.6l2.446-3.853h11.215l.57 3.853h7.01l.481-2.01L121.543 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "m142.61 0-7.974 9.381h-.97L130.176 0h-6.423l-.481 2.007 5.836 14.611-1.623 6.835h7.6l1.62-6.835 12.809-14.61L150 0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelay);
export default __webpack_public_path__ + "static/media/reelay.4ad342305f7bb3c09b7ad505ea55967b.svg";
export { ForwardRef as ReactComponent };